import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import useAuth from 'hooks/useAuth';
import MaintenanceScreen from 'views/maintenance/MaintenanceScreen';

// ==============================|| MAINTENANCE GATE ||============================== //
// Affiche un écran de maintenance plein page si le flag global est actif
// ET que l'email de l'utilisateur connecté n'est pas dans la liste d'exclusions.

const normalize = (email) => String(email || '').trim().toLowerCase();

const MaintenanceGate = ({ children }) => {
    const { isLoggedIn, user } = useAuth() || {};
    const { disabled, excludedEmails, loaded } = useSelector(
        (state) => state.settings?.interfaceStatus || { disabled: false, excludedEmails: [], loaded: false }
    );

    if (!isLoggedIn || !loaded || !disabled) {
        return children;
    }

    const userEmail = normalize(user?.email);
    const isExcluded = userEmail && excludedEmails.some((e) => normalize(e) === userEmail);

    if (isExcluded) {
        return children;
    }

    return <MaintenanceScreen />;
};

MaintenanceGate.propTypes = {
    children: PropTypes.node
};

export default MaintenanceGate;
